import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AuthService } from '@schoolbelle/api/auth';
import { GroupMember, GroupMemberService } from '@schoolbelle/api/group-member';
import { uniq, forEach } from 'lodash-es';
import { of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GroupService } from '@schoolbelle/api/group';
import { TranslationService } from '@schoolbelle/common/translation';
import { sprintf } from 'sprintf-js';
import { AuthorNameService } from './author-name.service';

@Component({
  selector: 'app-letter-write-profile',
  templateUrl: './letter-write-profile.component.html',
  styleUrls: ['./letter-write-profile.component.css'],
})
export class LetterWriteProfileComponent implements OnInit {
  private _author_name:string;
  @Input() set author_name (v:string) {
    if (this._author_name === v) return;
    this._author_name = v;
    this.author_nameChange.next(this._author_name);
  }
  get author_name () {
    return this._author_name;
  }
  @Output() author_nameChange = new EventEmitter();
  
  subscription = new Subscription();
  possible_author_names:string[] = [];
  constructor(
    public auth:AuthService,
    private group:GroupService,
    private member:GroupMemberService,
    private cdRef:ChangeDetectorRef,
    private elementRef:ElementRef,
    private translation:TranslationService,
    private authorName:AuthorNameService, // 
  ) { }

  ngOnInit() {
    this.loadAuthorName(); //
  }

  //
  loadAuthorName() {
    const gid = this.group.currentGroup.gid;
    this.authorName.get(gid).then(authorName=>{
      if(this.possible_author_names.indexOf(authorName) !== -1) {
        this.author_name = authorName;
      } else {
        this.authorName.remove(gid);
        this.author_name = this.possible_author_names[0];
      }
    })
  }

  //
  setAuthorName() {
    const gid = this.group.currentGroup.gid;
    this.authorName.set(gid, this.author_name);
  }

  watchAuthorNameList () {
    return of(null)
    .pipe(
      switchMap(()=>{
        if (!this.group.currentGroup || this.member.mine.length > 0) {
          return of(null);
        } else {
          return this.member.checkInMine();
        }
      })
    )
    .subscribe(()=>{
      const members = this.member.mine.filter(m=>m.member_user_id === this.auth.currentUser.uid);
      this.possible_author_names = members.map(m=>this.turnMemberToAuthorName(m))
      .map(v=>v.trim())
      .filter(v=>v);

      this.possible_author_names.push(this.auth.currentUser.name);
      this.possible_author_names = uniq(this.possible_author_names);
      
      if (!this.author_name) {
        this.author_name = this.possible_author_names[0];
      }
      this.cdRef.detectChanges();
    });
  }

  turnMemberToAuthorName (m:GroupMember):string {
    switch(m.member_type) {
      case 'parent' :
        return sprintf(this.translation.get('letter-write-profile-parent'), m.student_member_name);
      case 'student':
        return sprintf(this.translation.get('letter-write-profile-student'), m.member_name);
      case 'admin':
      case 'faceadmin':
        return sprintf(this.translation.get('letter-write-profile-admin'), m.member_name);
      case 'faculty':
        return sprintf(this.translation.get('letter-write-profile-faculty'), m.member_name);
      default:
        return null;
    }   
  } 

  ngAfterViewInit(): void {
    forEach(this.elementRef.nativeElement.querySelectorAll("div[translation-text]"), (el) => this.translation.set(el.id,  el.attributes["translation-text"].value))

    this.subscription.add(
      this.watchAuthorNameList()
    );
  }  

  ngOnDestroy () { 
    this.subscription.unsubscribe();
  }  
}